import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { FullOutsourceInvoiceWithProject, OutsourceInvoiceWithProject } from '../types';

export const outsourceInvoiceLoaders = getLoaders({
  outsourceInvoicesCounts: {
    load: async (): Promise<Record<string, number>> => {
      return executeApiCall({
        path: '/invoice/outsource-invoices/counts',

        method: 'get',
      });
    },
  },

  outsourceInvoicesByStatus: {
    load: async ({ status }: { status: string }): Promise<OutsourceInvoiceWithProject[]> => {
      return executeApiCall({
        path: '/invoice/outsource-invoices/by-status',

        method: 'get',

        payload: {
          status,
        },
      });
    },
  },

  activeOutsourceInvoices: {
    load: async (): Promise<OutsourceInvoiceWithProject[]> => {
      return executeApiCall({
        path: '/invoice/outsource-invoices/active',

        method: 'get',
      });
    },
  },

  findOutsourceInvoice: {
    load: async ({ id }: { id: string }): Promise<FullOutsourceInvoiceWithProject> => {
      return executeApiCall({
        path: `/invoice/outsource-invoices/${id}`,

        method: 'get',
      });
    },
  },
});
